<template>
  <div class="bg-white mt-5 rounded p-3 px-5">
    <div class="flex items-center border-b mb-6 pb-2">
      <div
        class="w-24 h-24 lg:w-32 lg:h-32 p-4 -mt-12 mb-0 lg:mb-2 rounded-lg relative flex-no-shrink"
        :class="page.icon_color ? page.icon_color : 'bg-tertiary'"
      >
        <icon name="videoettes" class="text-white" />
      </div>
      <h3 class="mx-6 text-3xl font-medium">
        Automation Settings
      </h3>
    </div>

    <div class="pb-4">
      <div class="mb-12">
        <h3 class="mb-2">Videoette Presets</h3>
        <p>
          Save your preferred presets here and they will become the defaults for
          all your property videoettes.
        </p>
      </div>

      <div class="mb-4 pb-8 overflow-x-scroll">
        <tabs
          v-model="tab"
          :options="[
            'Logo Animation',
            'Transitions',
            'Branding',
            'Call to Action',
            'Backing Music'
          ]"
        />
      </div>

      <logo-animation v-if="tab === 'Logo Animation'" v-model="logo" />
      <transitions v-if="tab === 'Transitions'" v-model="transition" />
      <branding v-if="tab === 'Branding'" v-model="branding" />
      <call-to-action v-if="tab === 'Call to Action'" v-model="cta" />
      <backing-music v-if="tab === 'Backing Music'" v-model="musicOptions" />
    </div>
  </div>
</template>

<script>
import api from '@/http'
import Branding from '@/components/Videoettes/Branding'
import Transitions from '@/components/Videoettes/Transitions'
import CallToAction from '@/components/Videoettes/CallToAction'
import BackingMusic from '@/components/Videoettes/BackingMusic'
import LogoAnimation from '@/components/Videoettes/LogoAnimation'
import Tabs from '@/components/Videoettes/Tabs'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'Presets',

  props: ['page'],

  components: {
    Tabs,
    Branding,
    Transitions,
    CallToAction,
    BackingMusic,
    LogoAnimation
  },

  computed: {
    ...mapState({
      selectedOffice: state => state.selectedOffice,
      logoItems: state => state.videoettes.logoItems,
      brandingItems: state => state.videoettes.brandingItems,
      transitionItems: state => state.videoettes.transitionItems
    }),

    cta () {
      if (!this.selectedOffice) return {}

      return {
        sales: {
          number: this.selectedOffice.sales_phone,
          email: this.selectedOffice.sales_email,
          website: this.selectedOffice.website
        },
        lettings: {
          number: this.selectedOffice.lettings_phone,
          email: this.selectedOffice.lettings_email,
          website: this.selectedOffice.website
        }
      }
    }
  },

  data () {
    return {
      tab: 'Logo Animation',
      musicOptions: [],
      logo: { id: null },
      branding: { id: null },
      transition: { id: null }
    }
  },

  methods: {
    ...mapActions([
      'displayToastNotification',
      'getVideoetteSettings'
    ]),

    getOfficePreset () {
      api
        .get(`/office/${this.selectedOffice.id}/preset`, {
          params: { type: 'videoette' }
        })
        .then(response => {
          // this.preset = response.data
          const payload = response.data
          this.logo = payload.logo
          this.branding = payload.branding
          this.transition = payload.transition
          this.musicOptions = payload.backing_music
        })
        .catch(error => {
          console.log(error)
        })
    },

    savePreset () {
      api
        .post(`office/${this.selectedOffice.id}/preset`, {
          type: 'videoette',
          logo_animation_id: this.logo ? this.logo.id : null,
          transition_id: this.transition ? this.transition.id : null,
          branding_id: this.branding ? this.branding.id : null,
          backing_music_ids: this.musicOptions.map(o => o.id)
          // logo_animation_colour: this.logoColour,
          // call_to_action: this.cta,
          // presenter_id: this.presenter,
        })
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },

  watch: {
    selectedOffice () {
      this.getVideoetteSettings()
      this.getOfficePreset()
    },

    logo: {
      handler: debounce(function () {
        this.savePreset()
      }, 1000),
      deep: true
    },

    transition: {
      handler: debounce(function () {
        this.savePreset()
      }, 1000),
      deep: true
    },

    branding: {
      handler: debounce(function () {
        this.savePreset()
      }, 1000),
      deep: true
    },

    musicOptions: {
      handler: debounce(function () {
        this.savePreset()
      }, 1000),
      deep: true
    }

  },

  mounted () {
    if (!this.selectedOffice && !this.selectedOffice.id) return

    this.getVideoetteSettings()
    this.getOfficePreset()
  }
}
</script>
